import React from 'react';
import PropTypes from 'prop-types';

import QuoteSOVButton from './quoteSOVButtons';

import {
  DueMonthlyWrapper,
  DueNowText,
  Amount,
  Title,
  ButtonsWrapper
} from './css';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const Mobile = ({
  isSendToSRT,
  isVBP,
  isFormTouched,
  isFormValidated,
  isOrderFulfillmentTeam,
  isSalesSupport,
  dueMonthly,
  dueNow,
  onSaveAndExit,
  onDownloadClick,
  onProceedClick,
  onValidateForm,
  onSendToSRT,
  onSubmit,
  onBack,
  onCancel,
  onPrintPDF,
  onSaveQuoteAsDocx,
  hidePricing,
  isQuoteApproved,
  isOrderSummary,
  onOpenOrderDetail,
  channelName
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: {
      DUE_MONTHLY,
      DUE_NOW,
      BEFORE_TAXES,
      saveQuoteAsPDF,
      saveAndContinueLater,
      printPdf
    },
    BUSINESS_APP_ORDERS: { saveQuote },
    formButtons: { submitButtonLabel, cancelButtonLabel, backButtonLabel }
  } = localizedStrings;
  return (
    <div id="footer-low">
      {!hidePricing && (
        <>
          <DueMonthlyWrapper>
            <DueNowText>
              <span className="frg-body-font-14px color-white">
                {DUE_MONTHLY}
              </span>
              <Title>{BEFORE_TAXES}</Title>
              <span className="frg-body-font-14px color-white">{DUE_NOW}</span>
              <Title>{BEFORE_TAXES}</Title>
            </DueNowText>

            <Amount>
              <span className="frg-body-font-14px color-white">&nbsp;</span>
              <span className="frg-body-font-27px color-white">
                <div id="footer-monthly-total-low">{dueMonthly}</div>
              </span>
              <span className="frg-body-font-14px color-white">&nbsp;</span>
              <span className="frg-body-font-27px color-white">
                <div id="footer-now-total-low">{dueNow}</div>
              </span>
            </Amount>
          </DueMonthlyWrapper>
        </>
      )}

      {isOrderFulfillmentTeam ? (
        <QuoteSOVButton
          isFormTouched={isFormTouched}
          isFormValidated={isFormValidated}
          onDownloadClick={onDownloadClick}
          onProceedClick={onProceedClick}
          onValidateForm={onValidateForm}
        />
      ) : (
        <ButtonsWrapper>
          {!isOrderSummary && (
            <button
              type="button"
              onClick={e => onSaveAndExit(e)}
              className="frg-button color-green"
              disabled={!isFormTouched && !isQuoteApproved}
            >
              <span>{saveAndContinueLater}</span>
            </button>
          )}
          {!isOrderSummary && (
            <button
              type="button"
              onClick={e => onSaveQuoteAsDocx(e)}
              className="frg-button color-green"
            >
              <span>{saveQuote}</span>
            </button>
          )}
          {!isOrderSummary && (
            <button
              type="button"
              onClick={e => onSubmit(e)}
              className="frg-button color-green"
            >
              <span>{submitButtonLabel}</span>
            </button>
          )}
          {isOrderSummary && (
            <button
              type="button"
              onClick={e => onBack(e)}
              className="frg-button color-green"
            >
              <span>{backButtonLabel}</span>
            </button>
          )}
          {isOrderSummary && (
            <button
              type="button"
              onClick={e => onPrintPDF(e)}
              className="frg-button color-green"
            >
              <span>{printPdf}</span>
            </button>
          )}
        </ButtonsWrapper>
      )}
    </div>
  );
};

Mobile.propTypes = {
  dueMonthly: PropTypes.string.isRequired,
  dueNow: PropTypes.string.isRequired,
  onDownloadClick: PropTypes.func.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  hidePricing: PropTypes.bool.isRequired,
  isSendToSRT: PropTypes.bool.isRequired,
  isVBP: PropTypes.bool.isRequired,
  isFormTouched: PropTypes.bool.isRequired,
  isFormValidated: PropTypes.bool.isRequired,
  isOrderFulfillmentTeam: PropTypes.bool.isRequired,
  isSalesSupport: PropTypes.bool.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
  onValidateForm: PropTypes.func.isRequired,
  onSendToSRT: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onPrintPDF: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onSaveQuoteAsPDF: PropTypes.func.isRequired,
  isQuoteApproved: PropTypes.bool.isRequired
};

export default Mobile;
